import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

/**
 * Global light/dark toggle. State lives in ThemeContext, so every instance
 * (the /app header and the Coin Detail header) toggles the same theme.
 */
export function ThemeToggle() {
  const { theme, toggle } = useTheme();

  return (
    <button
      onClick={toggle}
      className="flex items-center justify-center w-[34px] h-[34px] bg-slate-800 hover:bg-slate-700 border border-slate-700 rounded-lg transition-colors text-slate-400 hover:text-slate-200"
      title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {theme === 'dark'
        ? <Sun  className="w-4 h-4 transition-transform duration-300" />
        : <Moon className="w-4 h-4 transition-transform duration-300" />
      }
    </button>
  );
}
